/**
 * Vérifie si la largeur est inférieur à 450px
 */
import {IS_NATIVE} from "./SedestralUtils";

export function isTabletNative(): boolean {
    return ((window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth) >= 970) && IS_NATIVE;
}